import { render, staticRenderFns } from "./Countdetails.vue?vue&type=template&id=59bdb8c1&scoped=true"
import script from "./Countdetails.vue?vue&type=script&lang=js"
export * from "./Countdetails.vue?vue&type=script&lang=js"
import style0 from "./Countdetails.vue?vue&type=style&index=0&id=59bdb8c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bdb8c1",
  null
  
)

export default component.exports